import React from 'react';
import { Progress, Tooltip } from "antd";

import './progress-bar.css';

type ProgressComponentProps = {
    style?: string;
    percent: number;
    tooltipValue: string;
    textGradient?: boolean;
};

const ProgressComponent = ({
    style = 'orange',
    percent,
    tooltipValue,
    textGradient
}: ProgressComponentProps) => {
    return (
        <div className='px-6'>
            <Tooltip title={tooltipValue}>
                <>
                    <Progress
                        className={`dashboard-${style} ${textGradient && 'text-gradient'}`}
                        strokeColor={'#fff'}
                        trailColor={'#F5F5F580'}
                        showInfo={true}
                        percent={percent}
                    />
                </>
            </Tooltip>
        </div>
    )
}

export default ProgressComponent;